import "./Insights.scss";

interface IInsightsProps {}

function Insights(props: IInsightsProps) {
  return <div className="insights">insikter</div>;
}

export default Insights;
